import styled from 'styled-components';
import { Gray, White } from '../../../colors';
import { SCREEN_SIZE } from '../../grid/constants/sizes';
import { GridContainer, Row } from '../../grid';
export const BackgroundHeader = styled('div') `
    width: 100%;
    height: 90px;
    background-color: ${White.normal};

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
export const PageContainer = styled(GridContainer) `
    background-color: ${Gray.highLight};
`;
export const RowContent = styled(Row) `
    align-content: center;
    height: calc(100vh - 190px);

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: auto;
    }
`;
export const RowFooter = styled(Row) `
    width: 100%;
    height: 100px;
`;
export const RowHeader = styled(Row) `
    background-color: ${White.normal};
    height: 90px;
    z-index: 1000;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
//# sourceMappingURL=CollectionsSearchLayout.styled.js.map